var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGoogle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1211_7949)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M17.9824 10.527C17.9824 9.87328 17.9293 9.39626 17.8145 8.90158H10.3501V11.852H14.7316C14.6433 12.5852 14.1662 13.6894 13.1062 14.4314L13.0913 14.5302L15.4514 16.3585L15.615 16.3749C17.1166 14.988 17.9824 12.9474 17.9824 10.527Z",
    fill: "#4285F4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3501 18.3006C12.4966 18.3006 14.2987 17.5939 15.6149 16.3749L13.1062 14.4314C12.4348 14.8996 11.5338 15.2264 10.3501 15.2264C8.24769 15.2264 6.4633 13.8396 5.82722 11.9227L5.73398 11.9306L3.2799 13.8299L3.2478 13.9191C4.55517 16.5161 7.24061 18.3006 10.3501 18.3006Z",
    fill: "#34A853"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.82733 11.9227C5.65949 11.428 5.56236 10.898 5.56236 10.3503C5.56236 9.80258 5.65949 9.27258 5.8185 8.7779L5.81405 8.67254L3.32921 6.74279L3.24791 6.78146C2.70908 7.85918 2.3999 9.06942 2.3999 10.3503C2.3999 11.6312 2.70908 12.8413 3.24791 13.9191L5.82733 11.9227Z",
    fill: "#FBBC05"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.3501 5.4741C11.8429 5.4741 12.85 6.11895 13.4242 6.65784L15.6679 4.46708C14.2899 3.1862 12.4966 2.4 10.3501 2.4C7.24061 2.4 4.55517 4.18439 3.2478 6.78146L5.81839 8.7779C6.4633 6.861 8.24769 5.4741 10.3501 5.4741Z",
    fill: "#EB4335"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1211_7949"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 15.59,
    height: 15.9554,
    fill: "white",
    transform: "translate(2.3999 2.4)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogle);
export default __webpack_public_path__ + "static/media/google.c86185ba669f7aa4cf42ec1ad46fafc2.svg";
export { ForwardRef as ReactComponent };